
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91participantId_93OjziBUqUuSMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/data-check/[participantId].vue?macro=true";
import { default as detailsoPP05ZKIQDMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/details.vue?macro=true";
import { default as documentsAsP1ifTlTgMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/documents.vue?macro=true";
import { default as _91participantId_93yzUiA8PfLQMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/expert-opinion/[participantId].vue?macro=true";
import { default as index9JdmzRVPm8Meta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/index.vue?macro=true";
import { default as participants6oRet8veIPMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/participants.vue?macro=true";
import { default as protocolUn5imJl7ISMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/protocol.vue?macro=true";
import { default as _91id_93JT6C920J3jMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id].vue?macro=true";
import { default as indexE1BbisJGDCMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/index.vue?macro=true";
import { default as calendaro64gZUmeyRMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/calendar.vue?macro=true";
import { default as expertOpinionso60fzKhSTiMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/expertOpinions.vue?macro=true";
import { default as indexhtTp7z6wlNMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/index.vue?macro=true";
import { default as invoicesM98LwUNnuRMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/invoices.vue?macro=true";
import { default as routePlannerlbLGUyKdKnMeta } from "/builds/1tool/kfv-portal-trainer/pages/dashboard/routePlanner.vue?macro=true";
import { default as _91id_93aVpks8KpFLMeta } from "/builds/1tool/kfv-portal-trainer/pages/event-details/[id].vue?macro=true";
import { default as indexDyrD8W5BWwMeta } from "/builds/1tool/kfv-portal-trainer/pages/events-list/index.vue?macro=true";
import { default as index1hBTq10X7jMeta } from "/builds/1tool/kfv-portal-trainer/pages/events/index.vue?macro=true";
import { default as indexPj4ab11vEYMeta } from "/builds/1tool/kfv-portal-trainer/pages/index.vue?macro=true";
import { default as indexvB4f2Va6RhMeta } from "/builds/1tool/kfv-portal-trainer/pages/keyDates/index.vue?macro=true";
import { default as indexajRyRp6yGJMeta } from "/builds/1tool/kfv-portal-trainer/pages/login/index.vue?macro=true";
import { default as magic_45linka902q5gmTKMeta } from "/builds/1tool/kfv-portal-trainer/pages/login/magic-link.vue?macro=true";
import { default as indexmgoFTKLX2EMeta } from "/builds/1tool/kfv-portal-trainer/pages/mep/courses/index.vue?macro=true";
import { default as _91id_93XU4vmRUQyxMeta } from "/builds/1tool/kfv-portal-trainer/pages/project-details/[id].vue?macro=true";
import { default as indexGBMTQjq0YDMeta } from "/builds/1tool/kfv-portal-trainer/pages/projects/index.vue?macro=true";
import { default as indexGaNlvaLUZQMeta } from "/builds/1tool/kfv-portal-trainer/pages/proposals/index.vue?macro=true";
import { default as index5s3xDfHxLXMeta } from "/builds/1tool/kfv-portal-trainer/pages/report/index.vue?macro=true";
import { default as indexem1sA4V1HdMeta } from "/builds/1tool/kfv-portal-trainer/pages/reports/index.vue?macro=true";
import { default as indexUsYzysfu4XMeta } from "/builds/1tool/kfv-portal-trainer/pages/route-planner-projects/index.vue?macro=true";
import { default as index39UfOehErnMeta } from "/builds/1tool/kfv-portal-trainer/pages/signings/index.vue?macro=true";
import { default as _91token_93BeHijJrXJfMeta } from "/builds/1tool/kfv-portal-trainer/pages/wellbeing-sheet/[tenantId]/[token].vue?macro=true";
export default [
  {
    name: _91id_93JT6C920J3jMeta?.name,
    path: "/dashboard/:type()/:id()",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id].vue"),
    children: [
  {
    name: "dashboard-type-id-data-check-participantId",
    path: "data-check/:participantId()",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/data-check/[participantId].vue")
  },
  {
    name: "dashboard-type-id-details",
    path: "details",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/details.vue")
  },
  {
    name: "dashboard-type-id-documents",
    path: "documents",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/documents.vue")
  },
  {
    name: "dashboard-type-id-expert-opinion-participantId",
    path: "expert-opinion/:participantId()",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/expert-opinion/[participantId].vue")
  },
  {
    name: "dashboard-type-id",
    path: "",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/index.vue")
  },
  {
    name: "dashboard-type-id-participants",
    path: "participants",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/participants.vue")
  },
  {
    name: "dashboard-type-id-protocol",
    path: "protocol",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/[id]/protocol.vue")
  }
]
  },
  {
    name: "dashboard-type",
    path: "/dashboard/:type()",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/[type]/index.vue")
  },
  {
    name: "dashboard-calendar",
    path: "/dashboard/calendar",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/calendar.vue")
  },
  {
    name: "dashboard-expertOpinions",
    path: "/dashboard/expertOpinions",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/expertOpinions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-invoices",
    path: "/dashboard/invoices",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/invoices.vue")
  },
  {
    name: "dashboard-routePlanner",
    path: "/dashboard/routePlanner",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/dashboard/routePlanner.vue")
  },
  {
    name: "event-details-id",
    path: "/event-details/:id()",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/event-details/[id].vue")
  },
  {
    name: "events-list",
    path: "/events-list",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/events-list/index.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/events/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/index.vue")
  },
  {
    name: "keyDates",
    path: "/keyDates",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/keyDates/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/login/index.vue")
  },
  {
    name: "login-magic-link",
    path: "/login/magic-link",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/login/magic-link.vue")
  },
  {
    name: "mep-courses",
    path: "/mep/courses",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/mep/courses/index.vue")
  },
  {
    name: "project-details-id",
    path: "/project-details/:id()",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/project-details/[id].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/projects/index.vue")
  },
  {
    name: "proposals",
    path: "/proposals",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/proposals/index.vue")
  },
  {
    name: "report",
    path: "/report",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/report/index.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/reports/index.vue")
  },
  {
    name: "route-planner-projects",
    path: "/route-planner-projects",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/route-planner-projects/index.vue")
  },
  {
    name: "signings",
    path: "/signings",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/signings/index.vue")
  },
  {
    name: "wellbeing-sheet-tenantId-token",
    path: "/wellbeing-sheet/:tenantId()/:token()",
    component: () => import("/builds/1tool/kfv-portal-trainer/pages/wellbeing-sheet/[tenantId]/[token].vue")
  }
]